export default __webpack_public_path__ + "static/media/cover-3.eaad898b.jpg";